import script from "./WallpaperHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WallpaperHeader.vue?vue&type=script&setup=true&lang=ts"

import "./WallpaperHeader.vue?vue&type=style&index=0&id=379ca976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379ca976"]])

export default __exports__